import { MULTI_INSTANCE_BLOCKS } from 'components/TemplatesStudio/multiInstanceBlocks/multiInstanceBlocks.registry';

import {
  IAddBlockSection,
  IAddBlockSectionDeps
} from './AddBlockModal.types';

export const resolveTemplateStudioAddBlockSections = (
  deps: IAddBlockSectionDeps
): IAddBlockSection[] => {
  const enabledBlockSet = new Set(deps.enabledBlocks);
  const sections: IAddBlockSection[] = [];

  for (const descriptor of MULTI_INSTANCE_BLOCKS) {
    if (!enabledBlockSet.has(descriptor.block)) continue;
    sections.push({
      id: `multi-${descriptor.block}`,
      label: descriptor.modalRow.sectionLabel,
      rows: [
        {
          id: `multi-${descriptor.block}-add`,
          title: descriptor.modalRow.rowTitle,
          description: descriptor.modalRow.rowDescription,
          badgeLabel: descriptor.modalRow.badgeLabel,
          onAdd: () => deps.appendMultiInstance(descriptor.block)
        }
      ]
    });
  }

  return sections;
};
